import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/messaging'
import 'firebase/functions'
import 'firebase/firestore'
import utils from '../utils'

const options = {
  apiKey:
    utils.constants.env === 'STG'
      ? 'AIzaSyCr0ARKDCWKnu5z5CF4iwdyOCUpG7lck2U'
      : 'AIzaSyBC-j6qNcSyLUvKYuPCCWs8ADlR-8CUQR4',
  authDomain:
    utils.constants.env === 'STG'
      ? 'stg-muuve.firebaseapp.com'
      : 'muuve-87f5a-ufmj8bswo2mghs.firebaseapp.com',
  databaseURL:
    utils.constants.env === 'STG'
      ? 'https://stg-muuve.firebaseio.com'
      : 'https://prd-muuve-87f5a-ufmj8bswo2mghs.firebaseio.com',
  projectId: utils.constants.env === 'STG' ? 'stg-muuve' : 'muuve-87f5a-ufmj8bswo2mghs',
  storageBucket:
    utils.constants.env === 'STG'
      ? 'stg-muuve.appspot.com'
      : 'muuve-87f5a-ufmj8bswo2mghs',
  messagingSenderId: utils.constants.env === 'STG' ? '663038201041' : '307174907523',
}

const firebaseApp = firebase.initializeApp(options)

export default firebaseApp



// WEBPACK FOOTER //
// ./src/config/firebase.js